module.exports = __webpack_public_path__ + "static/media/cover.f354cc5e.png";